import { Button } from "../ui/button";

export const Callout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex flex-col gap-2 shadow-xs rounded-lg border-2 p-4 text-green-900 bg-green-600/10 border-green-800/30">
      <div>{children}</div>
    </div>
  );
};

export const SupplementsCallout = () => {
  return (
    <Callout>
      <div>
        <div className="font-bold text-lg">
          Our Reccomended Supplement Brands:
        </div>
        <ul>
          <li>
            <a
              style={{ textDecoration: "underline" }}
              href="https://shop.lifeseasons.com/supplements/?afmc=AMOS&utm_campaign=AMOS&utm_source=leaddyno&utm_medium=affiliate"
              target="_blank"
            >
              Life Seasons
            </a>
            - Use code AMOS at checkout for 10% off your purchase.
          </li>
          <li>
            <a
              style={{ textDecoration: "underline" }}
              href="https://www.metagenics.com/"
              target="_blank"
            >
              Metagenics
            </a>
            - Use code AmyleeAmos at checkout for a discount.
          </li>
          <li>
            <a
              style={{ textDecoration: "underline" }}
              href="https://www.cytoplan.co.uk/"
              target="_blank"
            >
              Cytoplan
            </a>
            - Use code CYT12417-10 at checkout for 10% off your purchase.
          </li>
        </ul>
      </div>
    </Callout>
  );
};

export const NutritionPlanCallout = () => {
  return (
    <Callout>
      <div>
        <div className="font-bold text-lg">Ketoflex Nutrition Plan Guide</div>
        <div>
          Click the button below to download your nutrition plan guide. The
          guide contains a 7-Day Meal Plan, recipes and a grocery shopping list.
        </div>
        <Button variant="outline" className="mt-4" asChild>
          <a
            href="https://amosinstitute-assets.s3-us-west-2.amazonaws.com/chp/downloads/KetoFlex+Nutrition+Plan+for+the+Bredesen+Protocol+-+7+Day+Meal+Plan.pdf"
            target="_blank"
          >
            Download Guide
          </a>
        </Button>
      </div>
    </Callout>
  );
};
